/**
 * @fileoverview "Add a to-do" (D50; Fable pass 1, item 1): a quiet full-width
 * row, a dashed square with a plus and the words in the primary colour, a
 * thumb and a half tall, the style of a bed's "Add a new plant here"
 * (BedPlants), so it is already known. It opens the own to-do sheet.
 *
 * Since E25 it is a plant's card's alone: Today and a bed's card draw "Add a
 * to-do" and "Plant something" side by side (AddAndPlantButtons), so the card
 * variant Today used (B60) went with it.
 *
 * Where: OwnTodosRow (a plant's card: the row itself with no to-do, the
 * list's last row with some).
 * API: none.
 * Words (en/es): todo.own.add.
 *
 * @module own-todos/AddTodoRow
 */

import React from 'react';
import { Plus } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from '@/shared/hooks/useTranslation';

/** The row's props. */
interface AddTodoRowProps {
  /** Opens the sheet. */
  onClick: () => void;
  /** More classes (a rule above it, its padding on a card). */
  className?: string;
}

/**
 * The "Add a to-do" row.
 *
 * @param props - AddTodoRowProps.
 */
export const AddTodoRow: React.FC<AddTodoRowProps> = ({ onClick, className }) => {
  const { reactTranslate: t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('flex min-h-12 w-full items-center gap-3 text-left text-[0.9375rem] font-semibold text-primary focus:outline-none focus-visible:ring-2 focus-visible:ring-ring', className)}
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border-[1.5px] border-dashed border-current" aria-hidden="true">
        <Plus className="h-4 w-4" />
      </span>
      {t('todo.own.add')}
    </button>
  );
};
